





































































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch, onBeforeUnmount} from "@vue/composition-api";
import axios from 'axios';

// Store
import { Endpoints } from '@/ts/store/Constants';
import ChannelListData from '@/ts/Channels/ChannelListData';
import { mapResponseToTenantData } from '@/views/Admin/Channels/mappingUtil';
import { TenantData } from '@/views/Admin/Channels/channelTypes';


// Components
import BaseModal from '@/components/NEW-STRUCTURE/desktop/Admin/modals/BaseModal.vue';
import TenantUser from '@/views/Admin/Channels/ChannelInviteMembers/components/TenantUser.vue';

export default defineComponent({
    components: {
        BaseModal,
        TenantUser,
    },
    props: {
        isVisible: Boolean,
        channel: ChannelListData,
        projects: Array,
        projectId: Number,
    },
    setup(props, context) {
        const store = context.root.$store;
        const showModal = computed({
            get() {
                return props.isVisible;
            },
            set(newValue) {
                context.emit('onClose', newValue);            
            },
        });

        const projectOptions = props.projects;

        const searchTenantText: Ref<string> = ref('');

        const showProjectDropdown: Ref<boolean> = ref(false);

        const selectedProjects: Ref<number[]> = ref([]);

        const selectedTenants: Ref<TenantData[]> = ref([]);

        const selectedTenantsIds: Ref<number[]> = ref([]);

        const tenants: Ref<TenantData[]> = ref([]);

        const tenantsOptions: Ref<TenantData[]> = ref([]);

        const selectAllTenants = () => {
            selectedTenantsIds.value = tenants.value.map((tenant) => tenant.id);
        }

        const deselectAllTenants = () => {
            selectedTenantsIds.value = [];
        }

        const toggleTenantSelection = (tenant: TenantData) => {
            if (!selectedTenantsIds.value.includes(tenant.id)) {
                selectedTenantsIds.value.push(tenant.id);
            } else {
                selectedTenantsIds.value = selectedTenantsIds.value.filter((tenantId) => { 
                    return tenantId !== tenant.id;
                });
            }
        }

        const checkIfTenantIsSelected = (tenantToCheck: TenantData) => {
            return selectedTenantsIds.value.some((tenantId) => {
                return (tenantId === tenantToCheck.id);           
            });
        }

        const handleProjectSelect = (projectId: number) => {
            selectedProjects.value;
            const isProjectSelected = selectedProjects.value.includes(projectId);

            if (isProjectSelected) {
                // remove projectId from selected projects
                selectedProjects.value = selectedProjects.value.filter((elem) => { 
                    return elem !== projectId;
                });
                // filter tenants 
                tenants.value = tenants.value.filter((tenant) => { 
                    return tenant.projectId !== projectId;
                });
                tenantsOptions.value = tenants.value;
                searchTenantText.value = '';
            } else {
                // add projectId to selected projects
                selectedProjects.value = selectedProjects.value.concat(projectId);
                // add tenants to the 
                fetchProjectTenants(projectId);
                searchTenantText.value = '';
            }
        }

        const toggleProjectSelection = () => {
            const newVal = !showProjectDropdown.value;
            showProjectDropdown.value = newVal;
        }

        const close = () => {
            clear();
            context.emit('onClose');
        }

        const clear = () => {
            searchTenantText.value = '';
            selectedProjects.value = [];
            selectedTenantsIds.value = [];
            showProjectDropdown.value = false;
            tenants.value = [];
            tenantsOptions.value = [];
        }

        const inviteMembers = () => {
            // TODO call endpoint to invite users and put the below content in then
            close();
            context.emit('showSuccessModal');

        }

        const fetchProjectTenants = (projectId: number) => {
            if (props.channel && props.channel.id) {
                // TODO change the endpoint to get the project tenants
                axios.get(Endpoints.Admin.Channels.CHANNEL_USERS(props.channel.id)).then((response) => {
                    if (response && response.data && response.data.data) {
                        const projectTenants = mapResponseToTenantData(response.data.data);
                        tenants.value = tenants.value.concat(projectTenants);
                        tenantsOptions.value = tenants.value;
                    }
                });
            }
        };

        const filterTenants = (tenants :TenantData[], queryText: String) => {
            const tenantsCopy = Array.from(tenants);
            return tenantsCopy.filter((tenant) => tenant.name.toLowerCase().includes(queryText.toLowerCase()));
        }

        watch(() => searchTenantText.value, (currentValue, oldValue) => {
            tenantsOptions.value = filterTenants(tenants.value, currentValue);
        });

        watch(() => props.projectId, (newProjectId, oldProjectId) => {
            clear();
            if (newProjectId) {
                handleProjectSelect(newProjectId);
            }
        });

        watch(() => props.channel, (newChannel, oldChannel) => {
            clear();
            if (newChannel) {
                handleProjectSelect(props.projectId);
            }
        });

        watch(() => props.isVisible, (newVisibility, oldVisibility) => {
            clear();
            if (newVisibility) {
                handleProjectSelect(props.projectId);
            }
        });

        onMounted(() => {
            if (props.projectId) {
                handleProjectSelect(props.projectId);
            }
        });

        onBeforeUnmount(() => {
           clear();
        });


        return {
            close,
            checkIfTenantIsSelected,
            deselectAllTenants,
            handleProjectSelect,
            inviteMembers,
            projectOptions,
            toggleTenantSelection,
            searchTenantText,
            selectedTenants,
            selectedTenantsIds,
            selectAllTenants,
            showModal,
            showProjectDropdown,
            tenants,
            tenantsOptions,
            toggleProjectSelection,
        };
    },
});
